module.exports = __webpack_public_path__ + "img/carousel-image2.e6618930.jpg";